var $797fa452cd967eb1$exports = {};
$797fa452cd967eb1$exports = {
    "collapse": `Recolher`,
    "columnResizer": `Redimensionamento de colunas`,
    "drag": `Arraste`,
    "expand": `Expandir`,
    "loading": `Carregando...`,
    "loadingMore": `Carregando mais...`,
    "resizeColumn": `Redimensionar coluna`,
    "sortAscending": `Ordenar por ordem crescente`,
    "sortDescending": `Ordenar por ordem decrescente`
};


export {$797fa452cd967eb1$exports as default};
//# sourceMappingURL=pt-BR.mjs.map
